import { toast } from '@/shared/lib/toast';
import { wsLogger } from '@/shared/lib/logger';
import { queryClient } from '@/shared/lib/query-client';
import { cacheKeys } from '@/shared/lib/cache-invalidation';
import { payloadString } from '../realtime-sync.payload';
import type { DataChangedEvent } from '../realtime-sync.types';

export async function handleReferenceUpdated(event: DataChangedEvent): Promise<void> {
  const payload = event.payload;
  const projectId = payloadString(payload, 'project_id');

  wsLogger.debug('[RealtimeSync] Reference updated:', {
    referenceId: event.id,
    projectId,
  });

  if (projectId) {
    queryClient.invalidateQueries({
      queryKey: cacheKeys.references.listsByProject(projectId),
    });
  }
}

export async function handleReferenceRejected(event: DataChangedEvent): Promise<void> {
  const payload = event.payload;

  wsLogger.warn('[RealtimeSync] Reference rejected:', {
    referenceId: event.id,
    projectId: payload?.project_id,
    reason: payload?.reason,
  });

  // Show toast notification — API-driven only.
  const referenceRejectedTitle = payloadString(payload, 'title');
  if (referenceRejectedTitle) {
    const description = payloadString(payload, 'message');
    toast.error(referenceRejectedTitle, {
      ...(description && { description }),
      duration: 8000,
    });
  }

  // Invalidate project references query
  const projectId = payloadString(payload, 'project_id');
  if (projectId) {
    queryClient.invalidateQueries({
      queryKey: cacheKeys.references.listsByProject(projectId),
    });
  }
}
